import React, { Fragment } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import parse from 'html-react-parser';
import ModalHeader from '@common-components/headers/ModalHeader';
import useAppSelector from '@hooks/useAppSelector';
import { environmentSelector } from '@selectors/commonSelectors';
import { entityModalTypes } from '@constants/entity/modals/entityModalTypes';
import  { TRANSFER_MODAL_MSG } from '@constants/entity/entityTranferBOBConfig';
import { ALL_USER_ROLES } from '@constants/roles/userRoleTypes';
const TransferPopupModal = props => {    
    const {
        modal:{
            modalData,
            modalType
        },
        modalHeaderProps,
        hideCloseIcon,
        userRole,
        actions: {
            hideModal,
            onHide
        }
    } = props;    
    const { AGENCY_MANAGER, BROKER_ADMIN, ASSISTERENROLLMENTENTITY, ASSISTERENROLLMENTENTITYADMIN, ADMIN } = ALL_USER_ROLES;
    const intlApi = useIntl();
    const { exchangeName } = useAppSelector(environmentSelector);
    const messageValues = { exchangeName, ...modalData };

    const handleCloseModal = () => {        
        if(onHide){
            onHide();
        }        
        hideModal();     
    };

    const getClasses = () => {
        switch(modalType){
            case entityModalTypes.TRANSFER_SUCCESS_MODAL : 
                return 'usa-alert gi-alert gi-alert__left-accent gi-alert__success';
            case entityModalTypes.TRANSFER_PARTIAL_SUCCESS_MODAL:
                return 'usa-alert gi-alert gi-alert__left-accent gi-alert__warning';
            case entityModalTypes.TRANSFER_VALIDATION_ERROR_MODAL :
            case entityModalTypes.TRANSFER_FAILURE_MODAL:
            case entityModalTypes.TRANSFER_ERROR_MODAL: 
                return 'usa-alert gi-alert gi-alert__left-accent gi-alert__error';
            default:
                return '';
        }
    };

    const getModalMessage = () => {
        if ([AGENCY_MANAGER, BROKER_ADMIN].includes(userRole)) {
            if (modalType === entityModalTypes.TRANSFER_FAILURE_MODAL) {
                if (userRole === BROKER_ADMIN) {
                    return <FormattedMessage id='bob.transfer.agency.admin.failure.msg' values={messageValues} />;
                } else if (userRole === AGENCY_MANAGER) {
                    return <FormattedMessage id='bob.transfer.agency.manager.failure.msg' values={messageValues} />;
                }
                return parse(intlApi.formatMessage({ id: TRANSFER_MODAL_MSG.Agency[modalType] }, messageValues));
            }
            return parse(intlApi.formatMessage({ id: TRANSFER_MODAL_MSG.Agency[modalType] }, messageValues));
        } else if ([ASSISTERENROLLMENTENTITY, ASSISTERENROLLMENTENTITYADMIN, ADMIN].includes(userRole)) {
            return parse(intlApi.formatMessage({ id: TRANSFER_MODAL_MSG[userRole][modalType] }, messageValues));
        }
    };

    return (
        <Fragment>
            <div className="gi-modal__header__head">
                <ModalHeader { ...{ ...modalHeaderProps }} hideCloseIcon={hideCloseIcon} hideModalCallback={handleCloseModal} />
            </div>
            <div className="gi-modal__body" id={`${modalHeaderProps.modalId}_body`}>
                <div className={getClasses()}>
                    <div className="gi-alert__body">
                        <p className="gi-alert__text">
                            {getModalMessage()}
                        </p>
                    </div>
                </div>
            </div>
            <div id='transfer-modal__footer' className="gi-modal__controls">
                {
                    modalType !== entityModalTypes.TRANSFER_IN_PROGRESS_MODAL ? <button onClick={handleCloseModal}
                        className="usa-button gi-button gi-button__primary">
                        <FormattedMessage id='button.close' />
                    </button> : null
                }
                
            </div>
        </Fragment>
    );
};

export default TransferPopupModal;
